import {GraphQLFormattedError} from 'graphql'

type ImportType = 'panelMember' | 'foundationCouncil'
type ManualTrigger = 'manual' | 'fileUpload'

// Same cap as the editor server's; validation errors can list every row, and
// the full text would exceed the server's JSON body limit (100 kB).
const MAX_REASON_LENGTH = 2000

interface ImportResult {
  errors?: readonly (string | null)[]
  validationErrors?: string
}

// Why a completed request failed, or undefined when it did not: GraphQL
// errors, or errors the import itself reported (validation errors among them).
export function importFailureReason(outcome: {
  errors: readonly GraphQLFormattedError[] | undefined
  result: ImportResult | undefined
}): string | undefined {
  if (outcome.errors?.length) return outcome.errors.map(({message}) => message).join('; ')

  const errors = outcome.result?.errors?.filter(Boolean) ?? []
  if (errors.length === 0) return undefined
  return [errors.join('; '), outcome.result?.validationErrors].filter(Boolean).join('\n\n')
}

// Asks the editor server (it holds the SMTP credentials) to email the
// recipients from Maintenance -> Email Notifications. Fire and forget: the user
// already sees the error in the toast, so a notification problem only logs.
export function reportImportFailure(
  importType: ImportType,
  trigger: ManualTrigger,
  reason: string
) {
  const token = localStorage.getItem('sessionToken')
  fetch('/import-notifications/failure', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token && {Authorization: `Bearer ${token}`}),
    },
    body: JSON.stringify({importType, trigger, reason: reason.slice(0, MAX_REASON_LENGTH)}),
  })
    .then((response) => {
      if (!response.ok) console.error('Import failure notification failed:', response.status)
    })
    .catch((error) => console.error('Import failure notification failed:', error))
}
